export default {
  state: {
    // 标签列表
    TabList: [],
    // 当前活动标签
    activeTab: '',
    dropdownMenu: false,
    dropdownTissue: false,
    TissueList:[],
    menuNameActive:"",
  },
  mutations: {
    updateTabList (state, tabs) {
      state.TabList = tabs
    },
    updateActiveTab (state, name) {
      state.activeTab = name
    },
    dropdownMenu (state, flag) {
      state.dropdownMenu = flag
    },
    dropdownTissue (state, flag) {
      state.dropdownTissue = flag
    },
    TissueList (state, tabs) {
      state.TissueList = tabs
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tabs.js